import React from 'react';

const ChainapproachTeaser = ({ entity }) => {

  return (
    <>Teaser Component</>
  );
};

export default ChainapproachTeaser;
